export const formatDateFields = [
  'created_on',
  'confirmed_on',
  'scheduled_on',
  'started_on',
  'started_on',
  'picked_on',
  'delivered_on',
]
